if (!customElements.get('snv-compact-reviews')) {
  customElements.define('snv-compact-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.snv-reviews__track');
      if (!this.track) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const scrollable = max > 4;
        this.classList.toggle('is-scrollable', scrollable);
        this.querySelector('.snv-reviews__controls').hidden = !scrollable;
        previous.disabled = this.track.scrollLeft < 4;
        next.disabled = this.track.scrollLeft >= max - 4;
      };
      const move = direction => {
        const card = this.track.querySelector('li');
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, {...options, passive: true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
